'use strict';

var React = require('react');
var dom = require('../../../helpers/dom.js');
var component = require('../../Tooltip/component.js');
var cellIcon_styles = require('./cellIcon.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const CellIcon = ({ name, label, withTooltip = true, tooltipPlacement = 'bottom', onClick, intent, size = 'm', ...props }) => {
    const targetRef = React.useRef(null);
    const [isTootlipOpen, setIsTooltipOpen] = React.useState(false);
    const onMouseOver = () => setIsTooltipOpen(true);
    const onMouseMove = (e) => {
        if ((targetRef && targetRef.current && targetRef.current.contains(e.target)) ||
            dom.isWithinRefElement(e.target, targetRef)) {
            return;
        }
        setIsTooltipOpen(false);
    };
    React.useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
        };
    }, []);
    return (React__default.default.createElement(cellIcon_styles.CellIconStyled, { ...props },
        React__default.default.createElement(cellIcon_styles.IconCell, { onMouseOver: onMouseOver, name: name, size: size, ref: targetRef, onMouseDown: onClick, onFocus: e => e.stopPropagation(), intent: intent }),
        withTooltip && isTootlipOpen && label && typeof label === 'string' ? (React__default.default.createElement(component.Tooltip, { placement: tooltipPlacement, target: targetRef.current, isOpened: isTootlipOpen, onOpenedChange: setIsTooltipOpen }, label)) : null));
};

exports.CellIcon = CellIcon;
//# sourceMappingURL=cellIcon.js.map
